import { Witness } from '../Model/Witness';
import { Query } from '../Model/Query';
import { v4 as v4uuid } from "uuid";
import { getCurrentUser } from "./session";
import { Third } from '../Model/Third';
export class WitnessService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(thirdId, diligenceId) {
        if (diligenceId) {
            const response = await this.apiService.get('witness/' + diligenceId + '/third_id/' + thirdId);
            if (!response.ok) {
                throw new Error(`Error al obtener el testigo.`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener witnessId.`);
        }
    }
    async findByDiligenceNumber(diligenceId) {
        if (diligenceId) {
            const response = await this.apiService.get('witness/' + diligenceId);
            if (!response.ok) {
                throw new Error(`Error al obtener el testigo.`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener witnessId.`);
        }
    }
    async findThirds(opts) {
        var _a, _b;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.diligenceId) {
                query.addFilter('diligence_id', [opts.filters.diligenceId]);
            }
            if ((_b = opts.filters) === null || _b === void 0 ? void 0 : _b.thirdId) {
                query.addFilter('third_id', [opts.filters.thirdId]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`witness/thirds?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los terceros.`);
            }
            const content = await response.json();
            return content.map(third => new Third(third).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async saveWitness(diligence) {
        if (diligence) {
            const response = await this.apiService.post('witness', diligence);
            if (!response.ok) {
                throw new Error(`Error al guardar el testigo.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener witness.`);
        }
    }
    async createWitness(thirdId, diligenceId) {
        if (thirdId && diligenceId) {
            const dateNow = new Date();
            const complainant = new Witness({
                id: v4uuid(),
                diligenceNumber: diligenceId,
                witnessThird: thirdId,
                manifestation: " ",
                date: dateNow.toString(),
                presents: " ",
                userId: getCurrentUser().id,
                third_name: null
            });
            const response = await this.apiService.post('witness', complainant.getState());
            if (!response.ok) {
                throw new Error(`Error al guardar el testigo Global de una diligencia`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el testigo Global`);
        }
    }
    async deleteWitness(thirdId) {
        if (thirdId) {
            const response = await this.apiService.post('witness/delete', { id: thirdId });
            if (!response.ok) {
                throw new Error(`Error al eliminar el testigo.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el testigo.`);
        }
    }
}
